<template>
  <div class="dashboard__view mb-5">
    <div class="page">
      <div class="page__title">Merchants</div>
    </div>

    <div class="page__nav">
      <div @click="$router.go(-1)" class="page__nav__icon">
        <svg
          fill="none"
          height="16"
          viewBox="0 0 19 16"
          width="19"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19 7L4.92969 7L9.5 2.42969L8 0.929687L0.929687 8L8 15.0703L9.5 13.5703L4.92969 9L19 9L19 7Z"
            fill="#655D79"
          />
        </svg>
      </div>
      <div @click="$router.go(-1)" class="page__nav__text mr-4">
        Merchant Details
      </div>
    </div>
    <div class="items-flex">
      <AccountStatement
        placeholder="Generate Account Statement"
        classes="left-0"
        no-status-text="transaction_status"
        :vnuban="this.$route.params.id"
      >
        <template>
          <button class="btn woven-color pt-3 pb-4">Generate Statement</button>
        </template>
      </AccountStatement>
      <button class="btn woven-color pt-3 pb-4" @click="generatePaymentLink">
        Generate Payment link
      </button>
    </div>
    <div class="details mt-4">
      <div class="details__card">
        <div class="details__card__container">
          <div class="details__card__header">Details</div>

          <div class="details__card__item">
            <div class="details__card__item__left">
              <div class="details__card__item__label">Business Name</div>
              <div class="details__card__item__value">
                {{ merchantList.business_name }}
              </div>
            </div>
            <div class="details__card__item__right">
              <div class="details__card__item__label">Business Nuban</div>
              <div class="details__card__item__value">
                {{ merchantList.business_nuban }}
              </div>
            </div>
          </div>
          <div class="details__card__item">
            <div class="details__card__item__left">
              <div class="details__card__item__label">Business Email</div>
              <div class="details__card__item__value">
                {{ merchantList.email }}
              </div>
            </div>
            <div class="details__card__item__right">
              <div class="details__card__item__label">Full Name</div>
              <div class="details__card__item__value">
                {{ merchantList.fullname }}
              </div>
            </div>
          </div>
          <div class="details__card__item">
            <div class="details__card__item__left">
              <div class="details__card__item__label">Mobile Number</div>
              <div class="details__card__item__value">
                {{ merchantList.mobile_number }}
              </div>
            </div>
            <div class="details__card__item__right">
              <div class="details__card__item__label">Status</div>
              <div class="details__card__item__value">
                {{ merchantList.status ? merchantList.status : "Active" }}
              </div>
            </div>
          </div>
          <div class="details__card__item">
            <div class="details__card__item__left">
              <div class="details__card__item__label">Date Created</div>
              <div class="details__card__item__value">
                {{ merchantList.created_at | date }}
              </div>
            </div>
            <div class="details__card__item__right">
              <div class="details__card__item__label">Current Balance</div>
              <div class="details__card__item__value">
                ₦ {{ formatAmount(merchantBalance) || 0 }}
              </div>
            </div>
          </div>
          <div class="details__card__item">
            <div class="details__card__item__left"></div>
            <div class="details__card__item__right visible-nop">
              <div class="details__card__item__label">
                <router-link
                  v-if="merchantList && merchantList.status"
                  :to="{
                    name: 'merchant-kyc-review',
                    params: { id: merchantList.id },
                  }"
                  class="btn btn--primary btn--filter"
                >
                  <span>View KYC Details</span>
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <QRTemplate
          :qrPaymentDetails="qrPaymentDetails"
          v-if="qrPaymentDetails"
          :download="download"
          @downloadedqr="download = null"
        />
      </div>
      <div class="details__trail"></div>
    </div>
  </div>
</template>

<script>
import AccountStatement from "@/components/accountStatementModal.vue";
import { formatAmount } from "@/lib/formatAmount.js";
import QRTemplate from "@/components/qrtemplate.vue";
export default {
  metaInfo: {
    title: "Merchant Details",
  },
  components: {
    AccountStatement,
    QRTemplate,
  },
  data() {
    return {
      merchantList: {},
      merchantBalance: 0,
      loading: false,
      qrPaymentDetails: null,
      download: null,
    };
  },

  created() {
    this.fetchMerchants();
  },

  methods: {
    formatAmount,
    getBankName(code, defaultValue = null) {
      const bank = this.$store.state.bankNames[code];
      console.log({ state: this.$store.state.bankNames, bank });
      return bank
        ? bank.name || bank.bank_short_name
        : defaultValue || "Not Available";
    },
    async generatePaymentLink() {
      try {
        const res = await this.$http.post(
          `api/admin/${this.$route.params.id}/payment_link`
        );
        const bank = res.data.data.bank_code;
        this.qrPaymentDetails = {
          slug: res.data.data.slug,
          qr_code: res.data.data.qr_code,
          merchant_name: this.merchantList.business_name,
          bank: this.getBankName(bank),
          vnuban: res.data.data.vnuban.vnuban,
        };
        this.download = "branded";
      } catch (error) {}
    },
    fetchMerchants() {
      this.$http
        .get(`admin/merchants?merchantId=${this.$route.params.id}`)
        .then((response) => {
          if (response.body.data.merchants.length > 0) {
            this.merchantList = response.body.data.merchants[0];
          }
        });
      this.$http
        .post(`dashboard/accounts/balance`, {
          merchantId: this.$route.params.id,
        })
        .then((response) => {
          this.merchantBalance = response.body.data.balance;
        });
    },
    async getAccountStatement() {
      this.$v.filterList.$touch();
      if (this.$v.filterList.$invalid) {
        return;
      }
      this.loading = true;
      await this.$store.dispatch("generateAccountStatement", {
        merchantId: this.$route.params.id,
      });
      this.loading = false;
      this.clearFilter();
    },
  },
};
</script>
<style>
.items-flex {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 20px;
  margin-bottom: 1rem;
}
.items-flex > button {
  height: 40px;
  color: #e00b5b !important;
  border-radius: 4px !important;
  background-color: white !important;
  border: 1px solid #e00b5b !important;
}
</style>
